import { render, staticRenderFns } from "./DatePickerRenderer.vue?vue&type=template&id=4256bc1c&"
import script from "./DatePickerRenderer.vue?vue&type=script&lang=js&"
export * from "./DatePickerRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports